// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"iconButton","iconButton--disabled":"iconButton--disabled"};